import { apiDaInscricao } from "../../../servicos/axios";

export interface EditarProjetoPayload {
  id: number;
  nome: string;
  idPrograma: number;
  descricao: string;
  dataInicio?: string;
  dataFim?: string;
  textoDeCiencia: string;
}

export const editarProjeto = async (payload: EditarProjetoPayload) => {
  const response = await apiDaInscricao().put("/projeto/editar", payload);
  return response.data;
};
